import { Injectable } from '@angular/core';

@Injectable()
export class FidelityNavigationStateService {
  private currentChecker: (() => boolean) | null = null;

  register(fn: () => boolean) {
    this.currentChecker = fn;
  }

  unregister() {
    this.currentChecker = null;
  }

  hasUnsavedChanges(): boolean {
    return this.currentChecker ? this.currentChecker() : false;
  }
}
